export default __webpack_public_path__ + "static/media/term-condition-bm.21d95143.svg";